/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import compareFields from "utils/compareFields";
import getBase64Details from "utils/getBase64Details";
import isObject from "utils/isObject";

import { extractNestedKey } from "hooks/usePagination";
import { getUser } from "lib/v2/usersApi";

import { getEnvs } from "state/EnvironmentsContext/EnvContext";
// This will be the User model, where all the code related to handling the user will be stored.
class User {
  constructor(user) {
    if (!user) return null;
    const {
      id,
      hash_id,
      first_name,
      last_name,
      email,
      avatar,
      image,
      ...rest
    } = user;

    this.user = user;
    this.id = id || hash_id;
    this.hash_id = hash_id;
    this.firstName = first_name;
    this.lastName = last_name;
    this.email = email;
    this.avatar = avatar || image;
    this.data = rest;
    this.loading = false;
    return this;
  }

  getAvatar = (user) => (user ? getAvatar(user) : this.avatar);
  getFullName = () => getFullName(this);
  getFirstName = () => this.firstName;
  getLastName = () => this.lastName;
  getEmail = () => this.email;
  getId = () => getUserId(this);
  getHashId = () => this.hash_id;

  fetchUser = async (userId) => {
    this.loading = true;
    const res = await getUser(userId);
    this.loading = false;
    return new User(res.data);
  };

  getUser = () => this.user;
  getRest = () => this.data;
}

export default User;

const getBase64Image = (base64String) => {
  const details = getBase64Details(base64String);
  return details.src;
};

export const getAvatar = (user) =>
  user && isObject(user)
    ? getBase64Image(user.personal_image) ||
      user.avatar ||
      user.image ||
      user.img ||
      getEnvs((state) => state.placeholder_small)
    : user;

export const isSameUser = (a, b) => {
  return !!compareFields(a, b, ["id", "hash_id"]);
};

export const getUserId = (user) => {
  let id;
  const userObject = extractNestedKey(user, "user");
  // if (user.hasOwnProperty("user")) {
  //   id = user?.user?.hash_id || user?.user?.id;
  // }
  // if (!id) {
  // id = user?.hash_id || user?.id;
  // }
  id = userObject?.hash_id || userObject?.id;
  return id;
};

export const getFullName = (user) => {
  // return `${user?.first_name || user?.firstName} ${
  //   user?.last_name || user?.lastName
  // }`;
  let fullName = "";
  if (user?.first_name || user?.firstName) {
    const firstName = user?.first_name || user?.firstName;
    fullName += firstName + " ";
  }

  if (user?.last_name || user?.lastName) {
    const lastName = user?.last_name || user?.lastName;
    fullName += lastName;
  }

  return fullName || user?.name || user?.title;
};
